var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalSearches(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0808105,
    width: 40,
    height: 40,
    rx: 10,
    fill: "#FFAC06",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5808 23.5L23.8308 24.75",
    stroke: "#FFAC06",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1919 26.8543C23.7105 26.3729 23.7105 25.5924 24.1919 25.1111C24.6732 24.6297 25.4537 24.6297 25.9351 25.1111L27.6364 26.8123C28.1178 27.2938 28.1178 28.0743 27.6364 28.5556C27.155 29.037 26.3745 29.037 25.8931 28.5556L24.1919 26.8543Z",
    stroke: "#FFAC06",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8308 18.9167C23.8308 15.695 21.2191 13.0833 17.9975 13.0833C14.7758 13.0833 12.1641 15.695 12.1641 18.9167C12.1641 22.1383 14.7758 24.75 17.9975 24.75C21.2191 24.75 23.8308 22.1383 23.8308 18.9167Z",
    stroke: "#FFAC06",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalSearches);
export default __webpack_public_path__ + "static/media/total-searches.a604c10d606f3e1a6b201d4194a5c229.svg";
export { ForwardRef as ReactComponent };